var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrix1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.602 3.88545C15.3472 3.07808 15.7198 2.6744 16.1157 2.43893C17.071 1.87076 18.2474 1.85309 19.2187 2.39232C19.6212 2.6158 20.0052 3.00812 20.7733 3.79276C21.5414 4.5774 21.9255 4.96972 22.1442 5.38093C22.6721 6.37312 22.6548 7.57479 22.0986 8.5507C21.8681 8.95516 21.4729 9.33578 20.6826 10.097L11.2789 19.1543C9.7812 20.5969 9.03232 21.3182 8.09638 21.6837C7.16044 22.0493 6.13152 22.0224 4.07368 21.9686L3.7937 21.9613C3.16723 21.9449 2.85399 21.9367 2.67191 21.73C2.48982 21.5234 2.51468 21.2043 2.5644 20.5662L2.5914 20.2197C2.73133 18.4235 2.80129 17.5255 3.15203 16.7182C3.50276 15.9109 4.10776 15.2555 5.31775 13.9445L14.602 3.88545Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5283 4L20.5283 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5283 22H22.5283",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix1);
export default __webpack_public_path__ + "static/media/matrix-1.34e87c4144490ee7475e610748757a7a.svg";
export { ForwardRef as ReactComponent };